import { render, staticRenderFns } from "./AddImageModal.vue?vue&type=template&id=070d3c7c&scoped=true&"
import script from "./AddImageModal.vue?vue&type=script&lang=js&"
export * from "./AddImageModal.vue?vue&type=script&lang=js&"
import style0 from "./AddImageModal.vue?vue&type=style&index=0&id=070d3c7c&prod&lang=css&"
import style1 from "./AddImageModal.vue?vue&type=style&index=1&id=070d3c7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070d3c7c",
  null
  
)

export default component.exports